import {
  getReseller,
  getResellerCompanies,
  getResellerList,
  updateReseller,
  createReseller,
} from '../../api/reseller';
import invalidationManager from './InvalidationManager';
import Reseller from '../../model/reseller';

export const { hook: useResellerList, fetcher: resellerListStore } =
  invalidationManager.createFetcher({
    queryKey: () => ['resellers'],
    fetchFunction: async () => {
      return getResellerList();
    },
  });

export const { hook: useResellerCompanies, fetcher: resellerCompaniesStore } =
  invalidationManager.createFetcher({
    queryKey: (resellerId?: string) => ['resellers', resellerId || 'no-id', 'companies'],
    fetchFunction: async (resellerId?: string) => {
      if (!resellerId) {
        return [];
      }
      return getResellerCompanies(resellerId);
    },
  });

export const { hook: useReseller, fetcher: resellerStore } = invalidationManager.createFetcher({
  queryKey: (resellerId: string) => ['resellers', resellerId],
  fetchFunction: async (resellerId: string) => {
    if (!resellerId) {
      return null;
    }
    return getReseller(resellerId);
  },
});

export const useCreateResellerMutation = invalidationManager.createMutationHook({
  mutationFunction: async (data: Omit<Reseller, 'id'>) => {
    await createReseller(data);
    await invalidationManager.invalidate(['resellers']);
  },
});

export const useUpdateResellerMutation = invalidationManager.createMutationHook({
  mutationFunction: async (resellerId: string, data: Partial<Reseller>) => {
    await updateReseller(resellerId, data);
    await invalidationManager.invalidate(['resellers', resellerId]);
    await invalidationManager.invalidate(['resellers']);
  },
});
